import React from "react";
import { useTheme, getColors } from "../ThemeContext";

const C = {
  card:"#0b1525", border:"#0f2040", cyan:"#00d4ff", green:"#00ff88",
  text:"#e2eaf8", muted:"#4a6080", panel:"#080f1e",
};
const MONO = "'Space Mono', monospace";
const SANS = "'Syne', sans-serif";

export default function LiftMethodSummary({ items = [], insight, accentColor = C.cyan }) {
  const { isDark } = useTheme();
  Object.assign(C, getColors(isDark));

  return (
    <div style={{
      background:C.card,
      border:`1px solid ${C.border}`,
      borderRadius:14,
      padding:"18px 16px",
      marginTop:20,
      marginBottom:20,
      width:"100%",
      boxSizing:"border-box",
      overflow:"hidden",
      clear:"both",
      position:"relative",
    }}>
      <div style={{
        position:"absolute", top:0, left:20, right:20, height:2,
        background:`linear-gradient(to right, transparent, ${accentColor}88, transparent)`,
      }}/>
      <div style={{ marginBottom:14 }}>
        <div style={{ fontFamily:SANS, fontWeight:700, fontSize:14, color:C.text }}>
          Operating Snapshot
        </div>
        <div style={{ fontFamily:MONO, fontSize:10, color:C.muted, marginTop:2 }}>
          Key operating values from the selected data
        </div>
      </div>

      <div style={{
        display:"grid",
        gridTemplateColumns:"repeat(auto-fit, minmax(min(100%, 220px), 1fr))",
        gap:10,
      }}>
        {items.map((item, index) => (
          <div key={`${item.label}-${index}`} style={{
            background:C.panel,
            border:`1px solid ${C.border}`,
            borderRadius:10,
            padding:"12px 14px",
            minWidth:0,
          }}>
            <div style={{
              fontFamily:MONO, fontSize:10, color:C.muted,
              textTransform:"uppercase", letterSpacing:.4,
            }}>
              {item.label}
            </div>
            <div style={{
              fontFamily:MONO, fontSize:19, fontWeight:700,
              color:item.color || accentColor, marginTop:5,
              overflowWrap:"anywhere",
            }}>
              {item.value == null ? "—" : item.value}
              {item.unit && <span style={{ fontSize:10, color:C.muted, marginLeft:4 }}>{item.unit}</span>}
            </div>
            {item.detail && (
              <div style={{ fontFamily:MONO, fontSize:10, color:C.muted, marginTop:5, lineHeight:1.4 }}>
                {item.detail}
              </div>
            )}
          </div>
        ))}
      </div>

      {insight && (
        <div style={{
          marginTop:12,
          padding:"10px 12px",
          background:`${accentColor}0d`,
          border:`1px solid ${accentColor}2a`,
          borderRadius:9,
          fontFamily:MONO,
          fontSize:11,
          color:C.text,
          lineHeight:1.55,
        }}>
          <span style={{ color:accentColor, fontWeight:700 }}>What the data shows: </span>
          {insight}
        </div>
      )}
    </div>
  );
}
